module.exports = __webpack_public_path__ + "img/parallax.1efa7ad5.jpg";